<template>
<div
    class="iframestyleset"
    v-loading="loading"
  >
      <el-row>
        <el-col
          :span="14"
          class="suitability_home left_text_align"
          @click.native="backHome"
          style="cursor: pointer;margin-left: 24px;"
        ><i class="el-icon-s-home"></i>返回主页菜单
        <!-- <div class="imgs_logo" /> -->
        </el-col>
        <el-col
          :span="9"
          @click.native="logoutAccount"
          class="suitability_home right_text_align"
          style="cursor: pointer;width: 38.4%;"
        >
          <span class="font_title_email">{{ account }}</span><span>[退出]</span>
        </el-col>
      </el-row>
        <iframe name="iframeMap" id="iframeMapViewComponent" width="100%" height="100%"
          src="managerTagging.html"
          frameborder="0"
          ref="newScreen"
          @load="sendMessage"
          scrolling="yes"
        ></iframe>
</div>
</template>
<script>
const componentsCommon = require("cb-components-common").default;
const getNameAndValue = componentsCommon.localStorage.getNameAndValue;
const logout = componentsCommon.common.logout;
export default {
  data() {
        return {
            account: ""
          };
        },
  mounted() {
        let self = this;
        let userInfo = getNameAndValue("info");
        self.iframeWin = self.$refs.newScreen.contentWindow;
        if (userInfo != undefined && userInfo != null && userInfo != "") {
            const user = JSON.parse(userInfo);
            self.account = user.email;
        } else {
            logout(self);
        }
    },
  methods: {
        sendMessage() {
          let userInfo = getNameAndValue("info");
            this.iframeWin.postMessage({ clientId: JSON.parse(userInfo).clientId,managerTagging: JSON.parse(userInfo).managerTagging }, '*')
          },
        backHome() {
            let self = this;
            // self.$router.go(-1);
            self.$router.push({
                path: "/home"
            });
        },
        logoutAccount() {
            let self = this;
            logout(self);
        }
  }
}
</script>
<style lang="scss">
.iframestyleset{
  width: auto;
  height: 98%;
  overflow: hidden;
}

#iframeMapViewComponent{
  margin-top: -10px;
}

.imgs_logo {
    height: 25px;
    width: 100px;
    margin-top: -2%;
    margin-left: 69%;
    background: url("../../public/images/logo_image.png") no-repeat;
}
</style>